import type { ReactNode } from 'react'

// Metric tile shared by the Purchase Orders KPI strip and the Events Analysis
// summary. The 3px left rule is brand IDENTITY, never a status signal; any
// status colour belongs on the value itself.
export function MetricCard({
  label,
  value,
  delta,
  accent,
  title,
}: {
  label: string
  value: ReactNode
  delta?: ReactNode
  accent?: boolean
  title?: string
}) {
  return (
    <div
      className="flex-1 border-l-[3px] border-l-[var(--brand)] border-r border-r-[var(--line-warm)] px-4 py-3 last:border-r-0"
      title={title}
    >
      <div className="text-[10px] uppercase tracking-[0.06em] text-[var(--mute)] mb-1">
        {label}
      </div>
      <div className="text-xl font-semibold tracking-tight text-[var(--text-primary)]">
        {value}
      </div>
      {delta && (
        <div
          className={`text-[11px] mt-0.5 ${accent ? 'text-[var(--accent)]' : 'text-[var(--ink-2)]'}`}
        >
          {delta}
        </div>
      )}
    </div>
  )
}
